<div class="container-fluid">
  <div class="col-md-12">
    <div class="row">
      <div class="col-md-10 pl-0">
        <div class="page-header">
          <h2>Manage Roles</h2>
          <p>Create new role and customize permissions.</p>
        </div>
      </div>
      <div class="col-md-2 pr-0">
        <div class="task-btn" (click)="createNewRole()">
          <!-- <button *ngxPermissionsOnly="['EDIT_ROLE']"
            class="im-btn button_whitebg im-btn-with-icon im-btn-outline-primary ml-5 mt-3">
            <div class="d-flex">
              <i class="fa fa-plus im-drop-icon"></i>&nbsp;
              <span>Create New</span>
            </div>
          </button> -->
          <button type="submit" class="btn btn-primary mt-0 float-right btn-add" *ngxPermissionsOnly="['EDIT_ROLE']">
            <i class="fa fa-plus-circle" aria-hidden="true"></i> <span>Create New</span></button>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="listRoles && listRoles.length > 0">
      <div class="col-md-9 pl-0">
        <a routerLink="../roleslist">
          <h5 class="heading"><b>List Of Roles</b></h5>
        </a>
      </div>
    </div>
  </div>

  <div class="role-accordion">
    <p-accordion class="role-accordion">
      <div class="border row">
        <div class="col-12 px-0">
          <p-accordionTab>
            <ng-template pTemplate="header">
              <div class="row notify">
                <div class="col-md-12">
                  <label>Standard Permission </label>
                </div>
              </div>
            </ng-template>
            <div class="row mt-2">
              <div class="col-md pr-0">
                <div class="row white_panel">
                  <div class="col-md-3 offset-md-9 pt-2">
                    <div class="input-group search-input-group float-right">
                      <input class="form-control py-2 rounded-pill pr-5" (keyup)="applyFilter($event)" type="search"
                        (search)="applyFilter($event)" placeholder="Search">
                      <span class="input-group-append">
                        <button class="btn rounded-pill border-0 ml-n5" type="button">
                          <i class="fa fa-search"></i>
                        </button>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="table-responsive mat-elevation-z8">
                      <table class="im-card-no-border-table table im-card-table-noborder-spacing table-striped-simple"
                        mat-table [dataSource]="dataSource" matSort>
                        <ng-container *ngFor="let column of columns" [matColumnDef]="column.columnDef" sticky>
                          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{column.header}} </th>
                          <td mat-cell *matCellDef="let row">
                            <span *ngIf="column.columnType=='text'">
                              {{row[column.columnDef]}}
                            </span>
                            <span class="ml-3" *ngIf="column.columnType=='check'">
                              <mat-checkbox [checked]="row[column.columnDef]" disabled
                                class="bordered-checkbox"></mat-checkbox>
                            </span>
                          </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        <ng-container matColumnDef="nodata">
                          <td mat-footer-row *matFooterCellDef [colSpan]="displayedColumns.length"
                            style="text-align: center;font-size:15px">No Roles Available</td>
                        </ng-container>
                        <tr mat-footer-row [hidden]="dataSource.data.length >0" *matFooterRowDef="['nodata']">
                        </tr>

                      </table>
                      <!-- <div *ngIf="dataSource.data.length === 0">No Records Found!</div> -->
                      <!-- <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </p-accordionTab>
        </div>
      </div>
    </p-accordion>

    <!---Module Permission accordion-->

    <p-accordion class="role-accordion">

      <p-accordionTab *ngFor="let item of modulePermissions; let i = index;">
        <ng-template pTemplate="header">
          <div class="row notify">
            <div class="col-md-12">
              <label> {{item?.moduleName}} </label>
            </div>
          </div>
        </ng-template>
        <div class="row">
          <div class="col-md-12">
            <div class="table-responsive mat-elevation-z8">
              <table class="im-card-no-border-table table im-card-table-noborder-spacing table-striped-simple" mat-table
                [dataSource]="buildDataSourceModule(item)" matSort>
                <ng-container *ngFor="let column of columns" [matColumnDef]="column.columnDef" sticky>
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> {{column.header}} </th>
                  <td mat-cell *matCellDef="let row;">
                    <span *ngIf="column.columnType=='text'">
                      {{row[column.columnDef]}}
                    </span>
                    <span class="ml-3" *ngIf="column.columnType=='check'">
                      <mat-checkbox [checked]="row[column.columnDef]" disabled class="bordered-checkbox"></mat-checkbox>
                    </span>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                <!-- <ng-container matColumnDef="nodata">
                  <td mat-footer-row *matFooterCellDef [colSpan]="displayedColumns.length"
                    style="text-align: center;font-size:15px">No Roles Available</td>
                </ng-container>
                <tr mat-footer-row [hidden]="dataSource.data.length >0" *matFooterRowDef="['nodata']">
                </tr> -->
              </table>
            </div>
          </div>
        </div>
      </p-accordionTab>
    </p-accordion>

  </div>
</div>
